module.exports = __webpack_public_path__ + "static/media/59.c1a722cc.png";